import { z } from 'zod';

export const PUBLIC_DOC_PATH = '/api/public/doc';

export const PUBLIC_FILE_PATH = '/api/public/file';

export function publicFileUrl(token: string, attachmentId: string): string {
  return `${PUBLIC_FILE_PATH}?token=${encodeURIComponent(token)}&id=${encodeURIComponent(attachmentId)}`;
}

export const publicDocResponseSchema = z.object({
  title: z.string(),
  bodyJson: z.array(z.record(z.string(), z.unknown())),
  ownerName: z.string(),
  cover: z.object({ url: z.string(), name: z.string() }).nullable(),
  updatedAt: z.number(),
  files: z.record(
    z.string(),
    z.object({
      name: z.string(),
      url: z.string(),
      mime: z.string(),
      sizeBytes: z.number(),
    }),
  ),
});

export type PublicDocResponseBody = z.infer<typeof publicDocResponseSchema>;
